import type React from "react";
import { isLight } from "./color";
import type { MarkingId } from "../types/configurator";

/** Visual treatment applied to the design layer so the preview reflects the marking technique. */
export function markingEffect(markingId: MarkingId | null, productHex: string): React.CSSProperties {
  switch (markingId) {
    case "gravure-laser":
    case "debossage":
      return isLight(productHex)
        ? { filter: "grayscale(1) brightness(0.35)", opacity: 0.55, mixBlendMode: "multiply" }
        : { filter: "grayscale(1) brightness(3)", opacity: 0.45, mixBlendMode: "screen" };
    case "broderie":
      return { filter: "drop-shadow(0 1px 0 rgba(0,0,0,0.35)) saturate(1.1)" };
    case "serigraphie":
    case "tampographie":
      return { filter: "saturate(1.15)" };
    default:
      return {};
  }
}

export function isToneOnTone(markingId: MarkingId | null): boolean {
  return markingId === "gravure-laser" || markingId === "debossage";
}
